<!--
  质控结果下拉选择组件
  使用示例：
  <select-qc-result-list v-model="search.qcResult"></select-qc-result-list>
-->
<template>
  <base-el-select v-model="value" :options="options" @input="handleInput" />
</template>

<script>
import BaseElSelect from './BaseElSelect.vue';
export default {
  name: 'SelectQcResultList',
  components: {
    BaseElSelect
  },
  props: ['value'],
  data: () => {
    return {
      options: [
        { label: '审核中', value: '-1' },
        { label: '未处理', value: '1' },
        { label: '已修改', value: '2' },
        { label: '已阅无误', value: '3' }],
    }
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val);
    }
  }
}
</script>
